import * as Sentry from "@sentry/astro";

function logError(error) {
  if (import.meta.env.PROD) {
    Sentry.captureException(error);
  } else {
    console.error(error);
  }
}

export { logError };
